// src/components/TicketButton.jsx
import { useNavigate } from 'react-router-dom';
import supportIcon from '../images/dm.png';
import api from './api';

const TicketButton = ({ packageId }) => {
    const navigate = useNavigate();

    const handleClick = async () => {
        if (!packageId) {
            console.error("packageId is required");
            return;
        }

        try {
            // ارسال درخواست GET به بک‌اند برای دریافت یا ایجاد تیکت
            const response = await api.get(
                `/pre_student/api/v3/tickets/get-or-create/${packageId}/`
            );
            
            if (response.status === 200 || response.status === 201) {
                const data = response.data;
                
                // بررسی وجود ticket_id در پاسخ
                if (data.ticket_id) {
                    // هدایت به صفحه تیکت با ticket_id
                    navigate(`/message-detail/${data.ticket_id}`);
                } else {
                    // در صورت عدم وجود ticket_id، با package_id برو
                    console.warn("No ticket_id in response, navigating with package_id");
                    navigate(`/message-detail/${packageId}`);
                }
            } else {
                // در صورت خطا، با package_id برو
                console.warn("API response not OK, navigating with package_id");
                navigate(`/message-detail/${packageId}`);
            }
        } catch (error) {
            console.error("Error getting ticket:", error);
            
            // در صورت خطا، با package_id برو (MessageDetail خودش مدیریت می‌کند)
            navigate(`/message-detail/${packageId}`);
        }
    };

    return (
        <div
            className="ticket-button-wrapper"
            style={{
                position: 'fixed',
                bottom: '100px',
                left: '20px',
                zIndex: 999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
            }}
            onClick={handleClick}
        >
            {/* حلقه نئون پشت آیکون */}
            <div
                style={{
                    position: 'absolute',
                    width: '100px',
                    height: '100px',
                    borderRadius: '50%',
                    background: 'rgba(40, 167, 69, 0.12)',
                    animation: 'pulse-ring 2s infinite',
                    zIndex: 0,
                    marginBottom: '10px',
                }}
            />
            
            {/* آیکون */}
            <img
                src={supportIcon}
                alt="پیام به مدرس"
                style={{
                    width: '70px',
                    height: '70px',
                    objectFit: 'contain',
                    filter: 'drop-shadow(0 6px 20px rgba(40, 167, 69, 0.35))',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    zIndex: 1,
                    marginBottom: '8px',
                }}
            />
            
            {/* نشانگر آنلاین */}
            <div
                style={{
                    position: 'absolute',
                    bottom: '32px',
                    right: '2px',
                    width: '16px',
                    height: '16px',
                    backgroundColor: '#4CAF50',
                    borderRadius: '50%',
                    border: '3px solid white',
                    zIndex: 2,
                    animation: 'blink 1.5s infinite',
                }}
            />

            {/* دکمه زیر آیکون */}
            <div
                style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    padding: '10px 22px',
                    borderRadius: '50px',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    boxShadow: '0 4px 15px rgba(40, 167, 69, 0.4)',
                    border: '2px solid rgba(255,255,255,0.2)',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    whiteSpace: 'nowrap',
                    marginTop: '4px',
                    position: 'relative',
                    zIndex: 1,
                    animation: 'bounce 2s infinite',
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.05)';
                    e.currentTarget.style.boxShadow = '0 6px 25px rgba(40, 167, 69, 0.5)';
                    e.currentTarget.style.backgroundColor = '#218838';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(40, 167, 69, 0.4)';
                    e.currentTarget.style.backgroundColor = '#28a745';
                }}
            >
                به مدرست پیام بده
            </div>

            {/* استایل‌های ریسپانسیو */}
            <style>{`
                /* دسکتاپ */
                @media (min-width: 769px) {
                    .ticket-button-wrapper {
                        bottom: 80px !important;
                        left: 20px !important;
                    }
                    
                    .ticket-button-wrapper img {
                        width: 70px !important;
                        height: 70px !important;
                    }
                    
                    .ticket-button-wrapper > div:first-child {
                        width: 100px !important;
                        height: 100px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        font-size: 15px !important;
                        padding: 10px 22px !important;
                    }
                }

                /* تبلت */
                @media (max-width: 1024px) and (min-width: 769px) {
                    .ticket-button-wrapper {
                        bottom: 90px !important;
                        left: 15px !important;
                    }
                    
                    .ticket-button-wrapper img {
                        width: 60px !important;
                        height: 60px !important;
                    }
                    
                    .ticket-button-wrapper > div:first-child {
                        width: 85px !important;
                        height: 85px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        font-size: 13px !important;
                        padding: 8px 18px !important;
                    }
                }

                /* موبایل */
                @media (max-width: 768px) {
                    .ticket-button-wrapper {
                        bottom: 85px !important;
                        left: 12px !important;
                    }
                    
                    .ticket-button-wrapper img {
                        width: 55px !important;
                        height: 55px !important;
                        margin-bottom: 6px !important;
                    }
                    
                    .ticket-button-wrapper > div:first-child {
                        width: 75px !important;
                        height: 75px !important;
                        animation: none !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        font-size: 12px !important;
                        padding: 7px 14px !important;
                        gap: 4px !important;
                        animation: none !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child span:first-child {
                        font-size: 15px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child span:last-child {
                        font-size: 8px !important;
                        padding: 1px 6px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        bottom: 28px !important;
                        right: 1px !important;
                        width: 14px !important;
                        height: 14px !important;
                        border-width: 2px !important;
                        animation: none !important;
                    }
                }

                /* موبایل کوچک */
                @media (max-width: 480px) {
                    .ticket-button-wrapper {
                        bottom: 75px !important;
                        left: 8px !important;
                    }
                    
                    .ticket-button-wrapper img {
                        width: 45px !important;
                        height: 45px !important;
                        margin-bottom: 4px !important;
                    }
                    
                    .ticket-button-wrapper > div:first-child {
                        width: 60px !important;
                        height: 60px !important;
                        display: none !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        font-size: 10px !important;
                        padding: 5px 10px !important;
                        gap: 3px !important;
                        border-width: 1.5px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child span:first-child {
                        font-size: 13px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child span:last-child {
                        font-size: 7px !important;
                        padding: 1px 4px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        bottom: 24px !important;
                        right: 0px !important;
                        width: 12px !important;
                        height: 12px !important;
                        border-width: 1.5px !important;
                    }
                }

                /* موبایل خیلی کوچک */
                @media (max-width: 380px) {
                    .ticket-button-wrapper {
                        bottom: 30px !important;
                        left: 10px !important;
                    }
                    
                    .ticket-button-wrapper img {
                        width: 70px !important;
                        height: 70px !important;
                        margin-bottom: 3px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child {
                        font-size: 9px !important;
                        padding: 4px 8px !important;
                        gap: 2px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child span:first-child {
                        font-size: 11px !important;
                    }
                    
                    .ticket-button-wrapper > div:last-child span:last-child {
                        display: none !important;
                    }
                }

                /* انیمیشن‌ها */
                @keyframes bounce {
                    0%, 100% {
                        transform: translateY(0);
                    }
                    50% {
                        transform: translateY(-5px);
                    }
                }

                @keyframes pulse-ring {
                    0% {
                        transform: scale(0.8);
                        opacity: 0.8;
                    }
                    100% {
                        transform: scale(1.3);
                        opacity: 0;
                    }
                }

                @keyframes blink {
                    0%, 100% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 0.3;
                    }
                }
            `}</style>
        </div>
    );
};

export default TicketButton;